export default __webpack_public_path__ + "static/media/star_quarter.eb7fae63.svg";